import { Navigation } from './components/navigation'
import { HeroSection } from './components/hero-section'
import { FeaturesSection } from './components/features-section'
import { PricingSection } from './components/pricing-section'
import { CTASection } from './components/cta-section'
import { Footer } from './components/footer'

export const LandingPage = () => {
  return (
    <div className="min-h-screen w-full bg-white dark:bg-neutral900 transition-colors scroll-smooth">
      <Navigation />
      <main>
        <HeroSection />
        <FeaturesSection />
        <PricingSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  )
}
